import { Seo } from "@/components/Seo";
import { Footer } from "@/components/Footer";
import { LinkSimple } from "@phosphor-icons/react";
import { useSiteInfo } from "@/lib/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["How do I book?", "Browse a property, choose your date, guests and booking type, then submit a booking request. The owner reviews and accepts it, after which you pay the advance to confirm."],
  ["How does payment work?", "Payments are processed securely online via Razorpay. You pay a booking advance to confirm; the balance is settled with the property (or online where enabled)."],
  ["How much advance do I pay?", "By default the advance is 25% of the total booking value. The exact amount is shown clearly before you pay."],
  ["Can I cancel?", "Yes. Cancellation and any refund follow the policy shown before payment — typically full refund 7+ days before, partial 3–6 days before, and no refund within 72 hours. Admin-configured values always apply."],
  ["How does a refund work?", "If your cancellation is eligible, a refund is calculated per the policy and processed back to your original payment method."],
  ["How do I contact the property?", "Once your booking is confirmed you'll find contact options on your booking details page, plus Avinya support on WhatsApp."],
  ["How do I list my property?", "Tap 'List Your Property', register as an owner, and complete your listing. Our team reviews it before it goes live."],
  ["How does Avinya commission work?", "Avinya charges a platform commission (default 10%) on confirmed bookings. Your net payout is shown transparently in your owner dashboard."],
];

export default function Help() {
  const info = useSiteInfo();
  return (
    <>
      <Seo title="Help Center & FAQs" path="/help" description="Frequently asked questions about booking, payments, cancellations and listing your property on Avinya Bookings." />
      <div className="px-4 py-8 md:px-6">
        <div className="mx-auto max-w-3xl">
          <h1 className="font-heading text-3xl font-bold text-stone-900 md:text-4xl">Help Center</h1>
          <p className="mt-2 text-stone-600">Answers to common questions about Avinya Bookings.</p>
          <Accordion type="single" collapsible className="mt-6" data-testid="help-faqs">
            {FAQS.map(([q, a], i) => (
              <AccordionItem key={i} value={`faq-${i}`}>
                <AccordionTrigger data-testid={`faq-${i}`} className="text-left font-medium">{q}</AccordionTrigger>
                <AccordionContent className="text-stone-600">{a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {info.razorpay_link && (
            <a data-testid="help-razorpay-link" href={info.razorpay_link} target="_blank" rel="noreferrer" className="mt-6 flex items-center gap-3 rounded-2xl border border-primary/30 bg-accent/40 p-4 hover:bg-accent">
              <LinkSimple size={24} className="text-primary" />
              <div><p className="font-heading font-semibold text-stone-900">Pay securely online</p><p className="text-sm text-stone-500">Use our Razorpay payment link (UPI / Cards) for advances and balances.</p></div>
            </a>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
